<!--全局变量-->
<script>
//const serverUrl = 'http://localhost:8081'
const serverUrl = 'https://talltalk.cn'
const webUrl = '192.168.0.100'
export default {
  name: 'Global',
  serverUrl,
  webUrl
}
</script>

<style scoped>

</style>
